import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  popoverPaper: {
    width: "400px",
    padding: theme.spacing(2.5),
  },
  notificationsTitle: {
    marginBottom: theme.spacing(3),
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "125%",
  },
  divider: {
    borderBottom: `1px solid ${grey[300]}`,
    marginBottom: theme.spacing(1),
  },
  dividerTop: {
    borderTop: `1px solid ${grey[300]}`,
    marginTop: theme.spacing(1),
  },
  scrollContainer: {
    overflow: "auto",
  },
  markAllAsReadButton: {
    backgroundColor: "transparent",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  noNotification: {
    padding: theme.spacing(2),
    textAlign: "center",
  },
}));

export default useStyles;
